import { render } from "./MaoLangModal.vue?vue&type=template&id=cff17a84&scoped=true"
import script from "./MaoLangModal.vue?vue&type=script&lang=js"
export * from "./MaoLangModal.vue?vue&type=script&lang=js"

import "./MaoLangModal.vue?vue&type=style&index=0&id=cff17a84&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff17a84"]])

export default __exports__